'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dxExamNotice = function dxExamNotice() {
  return import('@/page/dx-exam/exam-notice');
};
var dxpaper = function dxpaper() {
  return import('@/page/dx-exam/exam-paper');
};
var dxparsepaper = function dxparsepaper() {
  return import('@/page/dx-exam/exam-parse-paper');
};
var dxExamRecord = function dxExamRecord() {
  return import('@/page/dx-exam/exam-record');
};
var dxExamResult = function dxExamResult() {
  return import('@/page/dx-exam/exam-result');
};
exports.default = [{
  path: '/dxExamNotice',
  name: 'dxExamNotice',
  component: dxExamNotice,
  childred: [],
  meta: {
    title: '考前须知'
  }
}, {
  path: '/dxpaper',
  name: 'dxpaper',
  component: dxpaper,
  childred: [],
  meta: {
    title: '答卷'
  }
}, {
  path: '/dxExamRecord',
  name: 'dxExamRecord',
  component: dxExamRecord,
  childred: [],
  meta: {
    title: '考试结果'
  }
}, {
  path: '/dxExamResult',
  name: 'dxExamResult',
  component: dxExamResult,
  childred: [],
  meta: {
    title: '完成考试'
  }
}, {
  path: '/dxparsepaper',
  name: 'dxparsepaper',
  component: dxparsepaper,
  childred: [],
  meta: {
    title: '试题解析'
  }
}];